import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_COST_FILE_TEMPLATE_TITLE = 'UPDATE_COST_FILE_TEMPLATE_TITLE' as const;

export const updateCostFileTemplateTitle = (title: string) => ({
  data: { title },
  type: UPDATE_COST_FILE_TEMPLATE_TITLE,
});

export type UpdateCostFileTemplateTitleAction = DataAction<typeof UPDATE_COST_FILE_TEMPLATE_TITLE, { title: string }>;
